<div class="container">
  <div
    class="offset-sm-1 col-sm-10 pt-5 webview text-center"
    [@flyInOut]="'in'"
  >
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
      {{ question }}
    </h1>
    <div class="col-sm-6 col-md-6 col-xl-5 m-auto text-left">
      <label class="custom-control custom-checkbox chkbox mb-2" for="DontKnow">
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="DontKnow"
          value="I don't know"
          name="in_contract"
          [(ngModel)]="hgContract.value1"
          (click)="getIncontract($event)"
        />
        <label class="custom-control-label font20" for="DontKnow"
          >I don't know</label
        >
      </label>
      <label
        class="custom-control custom-checkbox chkbox mb-2"
        for="AlreadyExpired"
      >
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="AlreadyExpired"
          value="No, It already expired"
          name="in_contract"
          [(ngModel)]="hgContract.value2"
          (click)="getIncontract($event)"
        />
        <label class="custom-control-label font20" for="AlreadyExpired"
          >No, it already expired</label
        >
      </label>

      <div class="custom-control custom-checkbox chkbox mb-2">
        <input
          type="checkbox"
          class="custom-control-input mgntp10"
          id="Expires"
          value="Yes, it expires on"
          name="in_contract"
          [(ngModel)]="hgContract.value3"
          (click)="getIncontract($event)"
        />
        <label class="custom-control-label font20" for="Expires"
          >Yes, it expires on
        </label>
        <div style="display: inline" class="pull-right datepick" id="datepick3">
          <mat-form-field
            class="example-full-width"
            style="
              display: inline-block !important;
              position: relative !important;
              text-align: right !important;
            "
            appearance="fill"
          >
            <input
              style="color: black; margin-bottom: 6px"
              matInput
              [matDatepicker]="mobpicker"
              [min]="minDate"
              [(ngModel)]="model"
              (ngModelChange)="getDate()"
              disabled
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="mobpicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #mobpicker disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <p class="m-0 mt-4 text-muted text-center tapmsg">
        {{ questionObj.chkboxtype }}
      </p>

      <div class="container col-sm-8 webview text-center">
        <button *ngIf="showbutton" 
          class="btn next mr-2 disabledButton mt-2 font22 text-uppercase"
          [ngClass]="{ sectbtn: user_bot }"
          [disabled]="isDisable"
          (click)="next()"
        >
          Next
        </button>
      </div>
    </div>
    <br />
  </div>
</div>
<p class="m-0 text-muted tapmsg" style="color: #0055ff !important">
  <a
    href="javascript:void(0)"
    id="openModalButton"
    (click)="openModal(template)"
  >
  </a>
</p>
<p class="m-0 text-muted tapmsg" style="color: #0055ff !important">
  <a
    href="javascript:void(0)"
    id="openEmailModalButton"
    (click)="openEmailModalButton(emailtemplate)"
  >
  </a>
</p>

<p class="m-0 text-muted tapmsg" style="color: #0055ff !important">
  <a
    href="javascript:void(0)"
    id="openEmailModalSuucessButton"
    (click)="openEmailModalSuucessButton(emailtemplatew)"
  >
  </a>
</p>

<div class="container mobileview px-0 mb-4" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="col-sm-12 m-auto">
    <div class="col-12 px-0">
      <label
        class="custom-control custom-checkbox chkbox mb-2"
        for="DontKnow_mob"
      >
        <input
          type="checkbox"
          value="I don't know"
          name="in_contract"
          class="custom-control-input"
          id="DontKnow_mob"
          [(ngModel)]="hgContract.value1"
          (click)="getIncontract($event)"
        />
        <label class="custom-control-label" for="DontKnow_mob"
          >I don't know</label
        >
      </label>
    </div>
    <div class="col-12 px-0">
      <label
        class="custom-control custom-checkbox chkbox mb-2"
        for="AlreadyExpired_mob"
      >
        <input
          type="checkbox"
          value="No, It already expired"
          name="in_contract"
          class="custom-control-input"
          id="AlreadyExpired_mob"
          [(ngModel)]="hgContract.value2"
          (click)="getIncontract($event)"
        />
        <label class="custom-control-label" for="AlreadyExpired_mob"
          >No, it already expired</label
        >
      </label>
    </div>
    <div class="col-12 px-0" style="position: relative; z-index: 0">
      <div
        class="custom-control custom-checkbox chkbox mb-2"
        style="position: absolute; z-index: 1"
      >
        <input
          type="checkbox"
          style="display: inline-block"
          class="custom-control-input mgntp10"
          id="Expires_mob"
          value="Yes, it expires on"
          name="in_contract"
          [(ngModel)]="hgContract.value3"
          (click)="getIncontract($event)"
        />
        <label
          style="display: inline-block"
          class="custom-control-label font20"
          for="Expires_mob"
          >Yes, it expires on
        </label>
      </div>
      <div
        style="position: relative; z-index: 2"
        class="pull-right mt-1"
        id="datepick3"
      >
        <mat-form-field
          class="example-full-width"
          appearance="fill"
          style="
            display: inline-block !important;
            position: relative !important;
            text-align: right !important;
          "
        >
          <input
            style="color: black; margin-bottom: 6px"
            matInput
            [matDatepicker]="mobpicker1"
            [min]="minDate"
            [(ngModel)]="model"
            (ngModelChange)="getDate()"
            disabled
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="mobpicker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #mobpicker1 disabled="false"></mat-datepicker>
        </mat-form-field>
        <!-- <my-date-picker
        style="display: inline-block; right: 0"
        name="mydate"
        class="date-format"
        required
        [options]="myDatePickerOptions"
        id="date"
        [(ngModel)]="model"
        (ngModelChange)="getDate()"
        placeholder="MM/DD/YYYY"
        required
      ></my-date-picker> -->
      </div>
    </div>
    <div class="m-auto text-center">
      <p class="m-auto text-muted tapmsg p-0">{{ questionObj.chkboxtype }}</p>
    </div>
 
  </div>
  <div class="row" style="width: 97% !important; text-align: right">

    <div class="col-121" style="width: 100% !important; text-align: right">
      <div *ngIf="user_bot" class="ash_box text-right mt-2 mb-2">
        <h1 class="ansMob text-right">{{ ans_in_contract }}</h1>
      </div>
    </div>
  </div>

 
</div>

<ng-template #template>
  <div>
    <div class="modal-dialog" role="document">
      <div class="modal-content zind1 boxRadius">
        <div class="modal-body">
          <button
            type="button"
            class="close videoclose"
            id="closeModelAlign"
            data-dismiss="modal"
            aria-label="Close"
            (click)="hideModal()"
          >
            <div class="float-right mr-2">
              <img src="assets/images/editchart-close.svg" width="20" />
            </div>
          </button>

          <div class="service-modal px-sm-5">
            <h1
              class="
                text-center
                conthead
                font-weight-bold-calibre
                mt-4
                pt-2
                mb-3
              "
            >
              CHECK BACK WITH US IN {{ xDays }} {{ dayString }}
            </h1>
            <span style="clear: left"></span>
            <div class="bdy-section pt-0">
              <div>
                <p>
                  You're few days early. The soonest date that you can switch is
                  <span class="font-weight-bold">{{ switchedDatee }}</span
                  >.
                </p>
                <p>
                  There's a chance you may have to pay an early termination fee
                  or penalty for breaking your current agreement.
                </p>
                <p>
                  Because we don’t want that burden placed on you, please come
                  back and try again.
                </p>
                <p>See you soon!</p>
                <div class="col-12 px-0 webview">
                  <label
                    class="custom-control custom-checkbox chkbox mb-2"
                    for="IgnoreandProceed"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input mgntp10"
                      id="IgnoreandProceed"
                      value="IGNORE AND PROCEED"
                      name="in_contract_expires"
                      [(ngModel)]="hgContractExpires.value4"
                      (click)="onChangeRole($event)"
                    />
                    <label
                      class="custom-control-label font20"
                      for="IgnoreandProceed"
                      >IGNORE AND PROCEED</label
                    >
                  </label>
                  <label
                    class="custom-control custom-checkbox chkbox mb-2"
                    for="SendMeaRemainder"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input mgntp10"
                      id="SendMeaRemainder"
                      value="SEND ME A REMINDER"
                      name="in_contract_expires"
                      [(ngModel)]="hgContractExpires.value5"
                      (click)="onChangeRole($event)"
                    />
                    <label
                      class="custom-control-label font20"
                      for="SendMeaRemainder"
                      >SEND ME A REMINDER</label
                    >
                  </label>
                </div>
                <div class="col-12 px-0 mobileview">
                  <label
                    class="custom-control custom-checkbox chkbox mb-2"
                    for="IgnoreandProceedMob"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input mgntp10"
                      id="IgnoreandProceedMob"
                      value="IGNORE AND PROCEED"
                      name="in_contract_expires"
                      [(ngModel)]="hgContractExpires.value4"
                      (click)="onChangeRole($event)"
                    />
                    <label
                      class="custom-control-label font20"
                      for="IgnoreandProceedMob"
                      >IGNORE AND PROCEED</label
                    >
                  </label>
                  <label
                    class="custom-control custom-checkbox chkbox mb-2"
                    for="SendMeaRemainderMob"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input mgntp10"
                      id="SendMeaRemainderMob"
                      value="SEND ME A REMINDER"
                      name="in_contract_expires"
                      [(ngModel)]="hgContractExpires.value5"
                      (click)="onChangeRole($event)"
                    />
                    <label
                      class="custom-control-label font20"
                      for="SendMeaRemainderMob"
                      >SEND ME A REMINDER</label
                    >
                  </label>
                </div>
              </div>
              <div class="text-center mb-1 pt-2">
                <button
                  class="
                    btn
                    black-btn
                    mr-2
                    ml-2
                    col-12
                    font-weight-bold-calibre
                    contbtn
                  "
                  data-backdrop="false"
                  (click)="getSelected()"
                >
                  SEND
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #emailtemplatew>
  <div class="modal-dialog" role="document">
    <div class="modal-content zind1 boxRadius">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose"
          id="closeSuccessModelAlign"
          data-dismiss="modal"
          aria-label="Close"
          (click)="modalRef.hide()"
        >
          <!-- <span aria-hidden="true">&times;</span> -->
          <div class="float-right mr-1 mt-3">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
        <div class="col-sm-12 mt-4 mb-3 p-0">
          <span class="lnhgt15 plan-heading borderBtm">Thank you!</span>

          <div class="borderTp">
            <div class="pt-3">
              <div>
                <!-- <p class="sb-ttl font-weight-normal-calibre resettxt text-center">Uh-oh!<br> -->
                <!-- <hr> -->
                <font class="text-center esiidModal"></font>
                <!-- </p> -->
                <div
                  class="esiidModal"
                  style="font-size: 17px !important; line-height: 1 !important"
                >
                  Smart move for signing up! We will send you a reminder on
                  {{ switchedDatee1 }}, your first eligible date to shop for
                  your next energy plan.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="modal-dialog" role="document">
        <div class="modal-content zind1 boxRadius">
             <div class="modal-body">
                <button type="button" class="close videoclose" id ="closeSuccessModelAlign" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
                   
                    <div class="float-right mr-1 mt-1" >
                        <img src="assets/images/editchart-close.svg" width="20">
                    </div>
                </button> 
        <div class="service-modal px-sm-5">
    
        <div class="bdy-section pt-0 pl-0 mt-4">
        <div>
        <p>Thank you! Smart move on your part to sign up for this email reminder.</p>
        <p> 
        </p>
        
     
     
   </div>
  </div>
</div>

</div>
</div>
 </div> -->
</ng-template>

<ng-template #emailtemplate>
  <div class="modal-dialog" role="document">
    <div class="modal-content zind1 boxRadius">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose"
          id="closeEmailModelAlign"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeEmailModel(f)"
        >
          <!-- <span aria-hidden="true">&times;</span> -->
          <div class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="20" />
          </div>
        </button>
        <div class="service-modal px-sm-5">
          <h1 class="text-center conthead font-weight-bold-calibre mt-4">
            REMINDER WILL BE SENT IN {{ xDays }} {{ dayString }}
          </h1>
          <span style="clear: left"></span>
          <div class="bdy-section pt-0 pl-0 mt-4">
            <div>
              <p>
                Set a friendly reminder when your existing contract is set to
                expire.
              </p>
              <p>
                Next time you hear from us will be the soonest you can start
                shopping for a new energy plan.
              </p>

              <p>Choose from one of the options below:</p>

              <form
                name="form"
                (ngSubmit)="send($event, f, f.form.valid, 'contactModal')"
                #f="ngForm"
                novalidate
              >
                <div>
                  <div class="service-modal px-sm-5">
                    <div class="bdy-sec pt-0">
                      <div class="form-group row">
                        <label
                          for="email"
                          class="col-sm-3 col-2 col-form-label webview"
                          >EMAIL:
                        </label>
                        <label
                          for="email"
                          class="col-sm-3 col-2 col-form-label pl-0 mobileview"
                          >EMAIL:
                        </label>
                        <input
                          type="text"
                          class="col-sm-9 col-9 form-control inputshadow"
                          name="email"
                          [(ngModel)]="userObj.emailId"
                          (keydown.space)="
                            userObj.emailId ? null : $event.preventDefault()
                          "
                          #email="ngModel"
                          [ngClass]="{
                            'is-invalid': f.submitted && email.invalid
                          }"
                          required
                          email
                          pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
                        />
                        <div
                          *ngIf="f.submitted && email.invalid"
                          class="invalid-feedback"
                        >
                          <div
                            class="boxcolour float-right"
                            *ngIf="email.errors.required"
                          >
                            <span
                              class="fa fa-exclamation-circle mr-1"
                              type="Icon"
                            ></span
                            >Please enter email
                          </div>
                        </div>
                        <div
                          style="
                            float: left;
                            text-align: right !important;
                            width: 100% !important;
                            display: block !important;
                          "
                        >
                          <div
                            [hidden]="
                              email.valid ||
                              email.pristine ||
                              !email.errors.pattern
                            "
                            class="float-right"
                            style="float: right"
                          >
                            <div class="boxcolour alertMsg float-right">
                              <span
                                class="fa fa-exclamation-circle mr-1"
                                type="Icon"
                              ></span
                              >Please enter a valid email
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row mt-3">
                        <!-- <label for="contactQues">What's your burning question!</label> -->
                        <label
                          for="email"
                          class="col-sm-3 col-2 col-form-label webview"
                          >TEXT:
                        </label>
                        <label
                          for="email"
                          class="col-sm-3 col-2 col-form-label pl-0 mobileview"
                          >TEXT:
                        </label>
                        <input
                          type="tel"
                          appPhoneNumber
                          class="
                            col-sm-9 col-9
                            form-control
                            inputshadow
                            removeResize
                          "
                          #phone="ngModel"
                          minlength="12"
                          maxlength="12"
                          name="contactQues"
                          [(ngModel)]="userObj.contactQues"
                          (keydown.space)="
                            userObj.contactQues ? null : $event.preventDefault()
                          "
                          #contactQues="ngModel"
                          [ngClass]="{
                            'is-invalid': f.submitted && contactQues.invalid
                          }"
                          required
                        />
                        <!-- <div *ngIf="f.submitted && contactQues.invalid" class="invalid-feedback">
                <div *ngIf="contactQues.errors.required" class="boxcolour float-right"><span _ngcontent-c2="" class="fa fa-exclamation-circle mr-1"
                type="Icon"></span>Please enter phone number</div>
                </div> -->
                      </div>

                      <div style="font-size: 12px; padding-left: 3rem">
                        *Standard text message rates apply
                      </div>

                      <!-- <div  class="boxcolour float-right webview" style="padding-right:2.5rem;"><span *ngIf="f.submitted || f.form.email != undefined" 
                    type="Icon"></span>{{f.form.errors}}</div>
                    <div    class="boxcolour float-right mobileview" style="padding-right:7.5rem;"><span *ngIf="f.submitted || f.form.email != undefined" 
                        type="Icon"></span>{{f.form.errors}}</div> -->

                      <div
                        class="
                          form-group
                          float-label-control
                          text-center
                          mb-1
                          pt-2
                        "
                      >
                        <button
                          class="
                            btn
                            mr-2
                            mt-3
                            ml-2
                            col-12
                            font-weight-bold-calibre
                            contbtn
                          "
                          data-backdrop="false"
                        >
                          SEND
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
